import React, { Component } from "react";
import * as yup from "yup";
import { map } from "lodash";
import Modal from "antd/lib/modal/Modal";
import { Drawer, message, Select } from "antd";
import Loader from "../../../../Common/Component/Loader";
import AmountInput from "../../../../../Common/amountInput";
import { formatToCurrency } from "../../../../../Tools/formatToCurrency";

const { Option } = Select;
class PrePayment extends Component {
	fattJs = null;

	constructor(props) {
	  super(props);
	  this.state = {
	    response: "",
	    errors: {},
	    loader: false,
	    discounts: [],
	    card_list: [],
	    staff_list: [],
	    payment_type: '',
	    show_prices: false,
	    service_orders: [],
	    selected_months: 0,
	    issued_by_user: {},
	    issued_by_users: [],
	    selected_discount: 0,
	    calculated_price: {},
	    selected_service_order: '',
	    months: [1, 3, 6, 9, 12],
	    confirmation_modal_visible: false,
			
	    // Payment Details
	    log_type: '',
	    payment_log: {
	      cheque_payment: false,
	      is_check: false,
	      received_from: '',
	      amount_received: '',
	      cheque_id: '',
	      user_uuid: '',
	      received_by_uuid: '',
	      invoice_uuid: ''
	    },
			
	    // Card
	    card_count: 0,
	    card_cvv : '',
	    card_number : '',
	    new_card_uuid: '',
	    id_old_card: false,
	    card_payment_type: 0,
	    is_card_payment: true,
	    stax_customer_id : '',
	    card_expiry_year : '',
	    card_expiry_month : '',
	    hideAddNewButton: false,
	    stax_public_apikey: null,
	  }
	}

	componentDidMount = () => {
	  	const { customer, customerId } = this.props;
	  	let { payment_log } = this.state;
	  	let authUser = JSON.parse(localStorage.getItem('authUser'));

	  	this.props.getDiscounts({discount_type: 'CommercialPrepay'});
	  	this.props.getServiceOrders({user__uuid: this.props.customerId});

	  	const associated_field_offices = authUser?.user?.associated_field_offices?.map(x => x.uuid);
    	this.props.getStaffUsers({ staff_profile__field_office__uuid: associated_field_offices?.[0], invoice_list: true });

	  	payment_log = Object.assign(payment_log, {
	    	user_uuid: this.props.customer?.uuid,
	    	received_by_uuid: authUser?.user?.uuid,
	    	received_by: `${authUser?.user.first_name} ${authUser?.user.last_name}`,
	    	received_from: `${this.props?.crr_user?.user?.first_name} ${this.props?.crr_user?.user?.last_name}`
	  	});

		this.setState({
			payment_log,
			loader: true,
			franchise_uuid: associated_field_offices?.[0]
		});

		//Get User card list
		this.props.getCardList({ user__uuid: customerId });
		this.props.getInvoiceSummary({ user__uuid: customerId });
			
		if (Object.keys(customer).length > 0) {
			this.setState({ 
			stax_customer_id : customer?.stax_customer,
			stax_public_apikey: customer?.field_office?.stax_public_apikey,
			hideAddNewButton : customer?.field_office?.stax_public_apikey ? false : true
			})
		}
	}

	UNSAFE_componentWillReceiveProps = (nextProps) => {
	  const {
	    calculated_price,
	    service_orders,
	    new_card_uuid,
	    payment_type,
	    staff_list,
	    discounts,
	    response,
	    months
	  } = this.state;

	  let {payment_log} = this.state;

	  // Get list of Service Orders
		if (Object.keys(nextProps?.ServiceOrders.data).length > 0
			&& JSON.stringify(nextProps?.ServiceOrders.data) !== JSON.stringify(service_orders)) 
		{
			this.setState({ 
				loader: false,
				service_orders: nextProps?.ServiceOrders.data.data,
				});
		}
	  else if (Object.keys(nextProps?.ServiceOrders.errors).length > 0)
	  {
	    this.setState({loader: false});
	    message(nextProps?.ServiceOrders.errors);
	  }

	  // Get staff list
	  if (Object.keys(nextProps?.Invoice?.staffList).length > 0 && 
			JSON.stringify(this.nextProps?.Invoice?.staffList) !== JSON.stringify(staff_list)) 
	  {
	    this.setState({ staff_list: nextProps?.Invoice?.staffList?.results });
	  	}

	  else
	  {
	    this.setState({loader: false});
	  }

	  //Get Cars dlist
	  if (Object.keys(nextProps?.CardList?.data?.results).length > 0 && 
				nextProps?.CardList?.data?.results !== this.state?.card_list) {
	    if(nextProps?.CardList?.data?.count === 0){
			  this.setState({
				  card_payment_type:0,
				  is_card_payment: true,
				  id_old_card: true
	      });
	    }else{
			  this.setState({
				  card_payment_type:1,
				  is_card_payment: true,
				  id_old_card: false
	      });
	    }
	    this.setState({
			  card_count:nextProps?.CardList?.data?.count,
			  card_list: nextProps?.CardList?.data?.results,
	    });
	  }
	  
	  if (Object.keys(nextProps?.CardList?.errors).length > 0 && 
			nextProps?.CardList?.errors !== this.props?.CardList?.errors) {
	    this.setState({ loader: false});
	  }

	  //Add new card
	  if (Object.keys(nextProps?.AddCard?.data).length > 0 && 
			nextProps.AddCard?.data.uuid !== this.props?.AddCard?.data.uuid) {
	    this.setState({ new_card_uuid: nextProps?.AddCard?.data?.uuid}, () => {
	      this.onCreatePrepay();
	      this.props.updateSummary(this.props.customerId);
	    });
	  }
	  
	  if (Object.keys(nextProps?.AddCard?.errors).length > 0 && 
			nextProps?.AddCard?.errors !== this.nextProps?.AddCard?.errors) {
	    this.setState({loader: false});
	  }
	  
	  // Get Disounts List
	  if (Object.keys(nextProps?.Discounts?.data).length > 0
			&& JSON.stringify(nextProps?.Discounts?.data) !== JSON.stringify(discounts))
	  {
	    this.setState({
	      loader: false,
	      discounts: nextProps?.Discounts?.data?.discount_values
	    });
	  }

	  else if (Object.keys(nextProps?.Discounts.errors).length > 0)
	  {
	    this.setState({loader: false});
	    console.log(nextProps?.Discounts?.errors);
	  }

	  // Get calculated price for prepay
	  if (Object.keys(nextProps?.CalculatedPrepayPrice?.data).length > 0
			&& JSON.stringify(nextProps?.CalculatedPrepayPrice?.data) !== JSON.stringify(calculated_price))
	  {
	    if(payment_type === 'card')
	    {
	      payment_log = Object.assign(payment_log, { amount_received: nextProps?.CalculatedPrepayPrice?.data.prepay_amount !== 0 ? nextProps?.CalculatedPrepayPrice?.data.prepay_amount : ''});
	
	      this.setState({
	        payment_log,
	        loader: false,
	        show_prices: true,
	        calculated_price: nextProps?.CalculatedPrepayPrice?.data
	      });
	    }
	    else
	    {
	      this.setState({
	        loader: false,
	        show_prices: true,
	        calculated_price: nextProps?.CalculatedPrepayPrice?.data
	      });
	    }
	  }

	  else if (Object.keys(nextProps?.CalculatedPrepayPrice.errors).length > 0)
	  {
	    this.setState({loader: false});
	    console.log(nextProps?.CalculatedPrepayPrice?.errors);
	  }
	  
	  // Set stax customer detail
	  if (Object.keys(nextProps.StaxCustomer.data).length > 0) {
	    this.setState({
	      stax_customer_id:  nextProps?.StaxCustomer?.data?.stax_customer,
	      stax_public_apikey: nextProps?.StaxCustomer?.data?.field_office?.stax_public_apikey,
	      hideAddNewButton :  nextProps?.StaxCustomer?.data?.field_office?.stax_public_apikey ? false : true
	    });
	  }

	  if (this.state.hideAddNewButton) {
	    message.error('Error occur while loading stax. please contact to admin.', 500);
	  }

	  if (nextProps && nextProps?.Prepay && Object.keys(nextProps?.Prepay.data).length > 0 
			&& nextProps?.Prepay.data !== this.props?.Prepay?.data) {
	    this.setState({loader : false, respose: nextProps?.Prepay.data});
	    message.success("Your pre-pay was created successfully.");
	    this.props.updateSummary(this.props.customerId);
	    this.closeAndClear();
	  }
		  
	  if(nextProps?.Prepay && Object.keys(nextProps?.Prepay.errors).length > 0) {
	    this.setState({loader : false, errors:  nextProps?.Prepay.errors});
	    console.log(nextProps?.Prepay.errors);
	    message.error("Something went wrong");
	    this.closeAndClear();
	  }
	}

	onToggleLoader = (value) => {
	  this.setState({loader: value});
	  this.props.toggleLoader(value);
	}

	onServiceOrderChange = (e) => {
	  let { service_orders, selected_months, selected_discount } = this.state;
	  const item = service_orders.find((service_order) => service_order.uuid === e);
	
	  this.setState({selected_service_order: item.uuid, show_prices: false});
	  this.onCalculatePrice(selected_months, selected_discount, e);
	}

	onMonthsChange = (e) => {
	  let {payment_log} = this.state;
	  const {selected_discount, selected_service_order} = this.state;
	  payment_log = Object.assign(payment_log, { amount_received: '' });

	  this.setState({selected_months: e, show_prices: false, payment_log});
	  this.onCalculatePrice(e, selected_discount, selected_service_order);
	}

	onDiscountChange = (e) => {
	  let {payment_log} = this.state;
	  const {selected_months, selected_service_order} = this.state;
	  payment_log = Object.assign(payment_log, { amount_received: '' });
		
	  this.setState({selected_discount: e, show_prices: false, payment_log});
	  this.onCalculatePrice(selected_months, e, selected_service_order);
	}

	onCalculatePrice = (months, rate, service_order_uuid) => {
	  if(rate !== 0 && months !== 0 && 
			service_order_uuid !== '')
	  {
	    this.setState({show_prices: true});
	    this.props.calculatePriceForPrepay({
	      months,
	      rate,
	      service_order_uuid
	    });
	  }
	}

	onIssuedByChange = (e) => {
	  let { issued_by_user } = this.state;
	  issued_by_user = Object.assign(issued_by_user, { issued_by_user: {uuid: e, name: '3'}});
	
	  this.setState({issued_by_user});
	}

	//Close drawer and clear value
	closeAndClear = () => {
	  let { payment_log } = this.state;
	
	  payment_log = Object.assign(payment_log, {
	    cash_payment: false,
	    cheque_payment: false,
	    received_from: '',
	    amount_received: '',
	    cheque_id: '',
	    received_by_uuid: '',
	    is_check: false
	  });

	  this.setState({
		  payment_log,
		  log_type: '',
		  errors: {},
		  card_payment_type: 1,
		  new_card_uuid: '',
		  is_card_payment: true,
		  id_old_card: false,
		  calculated_price: {},
		  show_prices: false,
		  service_orders: [],
		  selected_service_order: ''
	  });

	  this.props.cleanPrePaymentResponse();
	  this.props.closeDrawer(false);
	}

	// Load Stax
	loadStax = () => {
	  const { stax_public_apikey } = this.state;
	  if (stax_public_apikey) {
		  const FattJs = window.FattJs;
		  const fattJs = new FattJs(stax_public_apikey, {
	      number: {
			  id: "card-number",
			  placeholder: "Card Number",
			  style: "height: 35px; width: 100%; font-size: 15px; font-family: Helvetica Neue, Helvetica; color: #31325f; font-weight: 300;"
	      },
	      cvv: {
			  id: "card-cvv",
			  placeholder: "CVV",
			  style: "height: 35px; width: 100%; font-size: 15px; font-family: Helvetica Neue, Helvetica; color: #31325f; font-weight: 300;"
	      }
		  });
		  fattJs.showCardForm().then(handler => {
	      console.log('form loaded', handler);
		  }).catch(err => {
	      console.error('error occur', err);
		  });
		  this.fattJs = fattJs;
	  } else {
		  message.error('Error occur while loading stax. please contact to admin.', 10);
	  }
	}

	// Add new card
	addNewCard = () => {
	  const { customer } = this.props;
	  const { card_expiry_month, card_expiry_year, card_number } = this.state;

	  this.setState({ loader : true });

	  const token_obj = {
		  address_1: customer ? customer.invoice_address.address : null,
		  address_city: customer ? customer.invoice_address.city : null,
		  address_state: customer ? customer.invoice_address.state : null,
		  address_zip: customer ? customer.invoice_address.zip_code : null,
		  month : card_expiry_month ? card_expiry_month : null,
		  year : card_expiry_year ? card_expiry_year : null,
		  card_number: card_number ? card_number : null,
		  email: customer && customer.email ? customer.email : null,
		  firstname: customer && customer.first_name ? customer.first_name : null,
		  lastname: customer && customer.last_name ? customer.last_name : null,
		  method: 'card',
		  person_name: customer ? `${customer.first_name} ${customer.last_name}` : null,
		  phone: this.state.card_phone
	  }
	  if (this.state.stax_customer_id) {
		  token_obj['customer_id'] = this.state.stax_customer_id;
	  }
		
	  this.fattJs.tokenize(token_obj).then((res) => {
		  if (res && Object.keys(res).length > 0) {
	      if (!customer.invoice_address.geo_location) {
			  delete customer.invoice_address.geo_location
	      }
	      this.props.addNewCard({
			  user_uuid: customer ? customer.uuid : null,
			  address: customer ? customer.invoice_address : null,
			  stax_card_token : res['id'] || null,
			  card_holder_name: customer ? `${customer.first_name} ${customer.last_name}` : null,
	      });
		  }
	  }).catch((err) => {
		  this.setState({ loader : false });
		  err.fieldErrors.map ((item) => {
	      message.error(item.message,10)
		  });
		  message.error(err.message,10);
	  });
	}

	// Validate required fields
	validatePrepay = () => {
	  const {
		  payment_log,
		  log_type,
		  card_payment_type,
		  is_card_payment,
		  new_card_uuid,
		  id_old_card,
		  card_number,
		  card_expiry_month,
		  card_expiry_year,
		  card_cvv,
		  calculated_price
	  } = this.state;

	  if (log_type === 'card' && card_payment_type === 0) {

		  const PaymentSchema = yup.object().shape({
	      card_number : this.fattJs.validNumber ? null : yup.string().required('Card Number is required'),
	      card_expiry_month : yup.string().nullable().required('Card expire month is required'),
	      card_expiry_year : yup.string().nullable().required('Card expire year is required').min(4, 'Card expire year is invalid.').max(4, 'Card expire year is invalid.'),
	      card_cvv : this.fattJs.validCvv ? null : yup.string().nullable().required('Card CVV is required'),
	      payment_log: yup.object().shape({
	        amount_received: calculated_price?.prepay_amount ? null : yup.string().required("Amount received is required"),
			    received_from: yup.string().required("Received from is required"),
			    user_uuid: yup.string().required("user_uuid is required"),
			    received_by_uuid: yup.string().required("Received by is required"),
			    cheque_id: yup.string().when('is_check', {
			    	is: true,
			    	then: yup.string().required('Check id is required'),
			    }),      
	      }),
	      is_card_payment: yup.bool(),
	      id_old_card: yup.bool(),
	      new_card_uuid: yup.string().when('id_old_card', {
			  is: true,
			  then: yup.string().required("Card is required"),
	      }),
		  });
	
		  const cardData = { 
	      payment_log,
	      log_type,
	      is_card_payment,
	      id_old_card,
	      new_card_uuid,
	      card_number,
	      card_expiry_month,
	      card_expiry_year,
	      card_cvv
		  };
	
		  PaymentSchema.validate(cardData, { abortEarly: false }).then(() => {
	      this.setState({ errors: {} });
	      this.addNewCard();
		  }).catch((error) => { 
	      let err_data = {};
	      map(error.inner, (item) => {err_data[item.path] = item.message})

	      if(error.errors.length > 0)
	        message.error("See field error messages in form");
			
	      this.setState({errors: err_data});
		  });
	  }else {

	    const PaymentSchema = yup.object().shape({
	      log_type: yup.string().required('Log type is required'),
	      payment_log: yup.object().shape({
	        amount_received: calculated_price?.prepay_amount ? null : yup.string().required("Amount received is required"),
	        received_from: yup.string().required("Received from is required"),
	        user_uuid: yup.string().required("user_uuid is required"),
	        received_by_uuid: yup.string().required("Received by is required"),
	        cheque_id: yup.string().when('is_check', {
	          is: true,
	          then: yup.string().required('Check id is required'),
	        }),      
	      }),
	      is_card_payment: yup.bool(),
	      id_old_card: yup.bool(),
	      new_card_uuid: yup.string().when('id_old_card', {
	        is: true,
	        then: yup.string().required("Card is required"),
	      }),
	    });

	    const cardData = { payment_log, log_type, is_card_payment, id_old_card, new_card_uuid };

	    PaymentSchema.validate(cardData, { abortEarly: false }).then(() => {
	      this.setState({ errors: {} });
	      this.onCreatePrepay();
	    }).catch((error) => { 
	      let err_data = {};
	      map(error.inner, (item) => {err_data[item.path] = item.message})
				
	      if(error.errors.length > 0)
	        message.error("See field error messages in form");
				
	      this.setState({errors: err_data});
	    });
	  }
	}

	onSearchReceivedBy = (search) => {
	  if (search?.length === 0 || search?.length >= 3) {
	    this.props.getStaffUsers({ search: search, staff_profile__field_office__uuid: this.state.franchise_uuid, invoice_list: true })
	  }
	}

	 //On Log text change
	onTextChange = (e) => {
	  let { payment_log } = this.state;
	  payment_log = Object.assign(payment_log, { [e.target.name]: e.target.value });

	  this.setState({payment_log});
	}

	//Receive by
	onReceiveChange = (e) => {
	  let { payment_log } = this.state;
	  payment_log = Object.assign(payment_log, { 'received_by_uuid': e });
	
	  this.setState({payment_log});
	}

	//Payment type change
	onLogTypeChange = (e) => {
	  let { payment_log,card_count } = this.state;
	  let authUser = JSON.parse(localStorage.getItem('authUser'));

	  payment_log = Object.assign(payment_log, {
	    cheque_id: '',
	    amount_received: '',
	    cash_payment: false,
	    cheque_payment: false,
	    received_by_uuid: authUser?.user?.uuid || '',
	    is_check: e.target.id === 'check' ? true : false,
	    received_from: `${this.props?.customer?.first_name} ${this.props?.customer?.last_name}`
	  });

	  this.setState({
	    errors: {},
	    payment_log,
	    log_type: e.target.id,
	    is_card_payment: e.target.id === 'card' ? true : false
	  });

	  if (e.target.id === 'card') {
	    if(card_count === 0) {
	      this.setState({
	        id_old_card: false,
	        card_payment_type: 0,
	      });

	      this.loadStax();
	    }
	    else
	    {
	      this.setState({
	        id_old_card: true,
	        card_payment_type: 1,
	      });
	    }
	  }
	}

	onCreatePrepay = () => {
	  const {
	    payment_log,
	    new_card_uuid,
	    selected_months,
	    is_card_payment,
	    calculated_price,
	    selected_discount,
	    selected_service_order,
	  } = this.state;

	  const data = {
	    "user_uuid": this.props.customer?.uuid,
	    "is_cc_pay": is_card_payment,
	    "prepay_credit": parseFloat(calculated_price?.prepay_amount),
	    "prepay_months": selected_months,
	    "received_by_uuid": payment_log?.received_by_uuid,
	    "is_check_pay": payment_log?.is_check,
	    "credit_discount": selected_discount,
	    "service_order_uuid": selected_service_order,
	    "check_number": payment_log?.cheque_id,
	    "received_from": payment_log?.received_from,
	    "user_billing_info": is_card_payment ? new_card_uuid : "",
	  }

	  this.setState({loader: true});
	  this.props.createPrepay(data);
	}

	onAmountChange = (value) => {
	  let {payment_log} = this.state;
	  payment_log = Object.assign(payment_log, { "amount_received": value });

	  this.setState({payment_log});
	}
	
	renderCheckPayment = () => {
	  let {payment_log, errors} = this.state;
	  const {staff_list, log_type, calculated_price} = this.state;

	  return <div className={log_type === 'check' ? 'form-group  log_card' : 'form-group'}>
	    <div className="p-30">
	      <div className="fitem text_with_place amount">
	        <label>Amount Received</label>
	        <div style={{"position": "relative"}}>
	          <AmountInput 
	            type="text"
	            className="twhite"
	            inputMode="decimal"
	            placeholder="0.00"
	            name="amount_received"
	            value={payment_log.amount_received}
	            onChange={this.onAmountChange}
	            onBlur={() => {
	              if(parseFloat(payment_log.amount_received).toFixed(2) !== 
									parseFloat(calculated_price.prepay_amount).toFixed(2))
	              {
	                errors = Object.assign(errors, {amount_received: "The Amount Received must match the Pre-pay Amount Due"});
	                payment_log = Object.assign(payment_log, { amount_received: '' });
	
	                this.setState({errors, payment_log});
	              }
	              else
	              {
	                this.setState({errors: {}});
	              }
	            }}
	          />
	        </div>
					
	        {errors['amount_received'] ? <label className="new_err_msg"><i className="las la-info-circle"></i>{errors['amount_received']}</label> : ''}
	        {payment_log.amount_received ? <div className="fix_isd_code t-25"><span>$</span></div> : ''}
	      </div>
	      <div className="fitem">
	        <label>Received From</label>
	        <input
	          type="text"
	          placeholder="" 
	          className="twhite"
	          name="received_from"
	          onChange={(e) => { this.onTextChange(e) }}
	          value={payment_log?.received_from ? payment_log?.received_from : ''}
	        />

	        {errors['payment_log.received_from'] ? <label className="new_err_msg"><i className="las la-info-circle"></i>{errors['payment_log.received_from']}</label> : ''}
	      </div>
	      <div className="fitem">
	        <label>Check ID #</label>
	        <input
	          type="text"
	          placeholder=""
	          className="twhite"
	          name="cheque_id"
	          value={payment_log?.cheque_id}
	          onChange={(e) => { this.onTextChange(e) }}
	          onPaste={(event) => {
	            if (event.clipboardData.getData('Text').match(/[^\d]/)) {
	              event.preventDefault();
	            }
	          }}
	          onKeyPress={(e) => {
	            const pattern = /[0-9]/;
	            const inputChar = String.fromCharCode(e.charCode);
	            if (!pattern.test(inputChar)) {
	              // invalid character, prevent input
	              e.preventDefault();
	            }
	          }}
	        />

	        {errors['payment_log.cheque_id'] ? <label className="new_err_msg"><i className="las la-info-circle"></i>{errors['payment_log.cheque_id']}</label> : ''}
	      </div>
	      <div className="fitem">
	        <label>Received By</label>
	        <Select
	          showSearch
	          defaultValue=""
	          className=""
	          filterOption={false}
	          value={payment_log?.received_by_uuid}
	          onChange={(e) => { this.onReceiveChange(e) }}
	          onSearch={(e) => this.onSearchReceivedBy(e)}
	          onBlur={() => this.onSearchReceivedBy()}
	        >
	          <Option value={payment_log?.received_by_uuid}>{payment_log?.received_by}</Option>
	          {
							staff_list?.results?.map((item) => {
							  return (
							    <Option key={item.uuid} value={item.uuid}>{item.first_name} {item.last_name}</Option>
							  )
							})
	          }
	        </Select>
					
	        {errors['payment_log.received_from'] ? <label className="new_err_msg"><i className="las la-info-circle"></i>{errors['payment_log.received_from']}</label> : ''}
	      </div>
	    </div>
	  </div>
	}

	renderCardPayment = () => {
	  const {
	    errors,
	    log_type,
	    card_list,
	    staff_list,
	    payment_log,
	    new_card_uuid,
	    calculated_price,
	    card_payment_type
	  } = this.state;

	  return <div className={log_type === 'card' ? 'form-group  log_card' : 'form-group'}>
	    <div className="p-30">
	      <div className="fitem text_with_place amount ">
	        <label>Amount Received</label>
	        <div style={{"position": "relative"}}>
	          <AmountInput
	            type="text"
	            disabled={true}
	            className="twhite"
	            inputMode="decimal"
	            placeholder="0.00"
	            name="amount_received"
	            value={parseFloat(calculated_price?.prepay_amount)?.toFixed(2)}
	          />
	        </div>
	        {errors['payment_log.amount_received'] ? <label className="new_err_msg"><i className="las la-info-circle"></i>{errors['payment_log.amount_received']}</label> : ''}
	        {payment_log.amount_received ? <div className="fix_isd_code t-25"><span>$</span></div> : ''}
	      </div>
	      <div className="fitem">
	        <label>Received From</label>
	        <input type="text"
	          className="twhite"
	          name="received_from"
	          value={payment_log.received_from}
	          onChange={(e) => { this.onTextChange(e) }}
	          placeholder=""
	        />
	        {errors['payment_log.received_from'] ? <label className="new_err_msg"><i className="las la-info-circle"></i>{errors['payment_log.received_from']}</label> : ''}
	      </div>
	      <div className="fitem half-fitem">
	        <div className="fitem half-fitem inline-check-list">
	          <div className="fitem-check">
	            <input
	              type="radio"
	              id="new_card"
	              className="fitem-ck-input"
	              checked={card_payment_type === 0}
	              onChange={() => {
	                this.setState({
	                  id_old_card: false,
	                  card_payment_type: 0,
	                  is_card_payment: true
	                });

	                this.loadStax();
	              }}
	            />
	            <label htmlFor="new_card" className="fitem-ck-txt">Add New Card</label>
	          </div>
	        </div>

	        <div className="fitem half-fitem inline-check-list">
	          <div className="fitem-check">
	            <input
	              type="radio"
	              id="old_card"
	              name="card_type"
	              className="fitem-ck-input"
	              checked={card_payment_type === 1}
	              onChange={() => {
	                this.setState({
	                  id_old_card: true,
	                  card_payment_type: 1,
	                  is_card_payment: false
	                });
	              }}
	            />
	            <label htmlFor="old_card" className="fitem-ck-txt">Use Existing Card</label>
	          </div>
	        </div>
	      </div>
	      {
	        card_payment_type === 1 ?
	          <div className="fitem">
	            <label>Card List</label>
	            <Select
	              className="swhite"
	              filterOption={false}
	              placeholder="Select Card"
	              value={new_card_uuid}
	              onChange={(e) => { 
	                this.setState({new_card_uuid: e});
	              }}
	            >
	              { 
	                card_list.map((item) => { return (
	                  <Option key={item.uuid}>{item?.card_holder_name}-{JSON.parse(item?.stax_payment_object)?.card_last_four}</Option>
	                )
	                })}
	            </Select>
	            {errors['new_card_uuid'] ? <label className="new_err_msg"><i className="las la-info-circle"></i>{errors['new_card_uuid']}</label> : ''}
	          </div> :
	          <React.Fragment>
	            <div className="fitem">
	              <label>Card Number</label>
	              <div id="card-number" className="form--control twhite"></div>
	            </div>
	            {
									errors?.['card_number'] ? 
									  <label className="new_err_msg">
									    <i className="las la-info-circle"/>{errors?.['card_number']}
									  </label> : ''
	            }
	            <div className="fitem">
	              <label>CVV</label>
	              <div id="card-cvv" className="form--control twhite"></div>
	            </div>
	            {
									errors?.['card_cvv'] ? 
									  <label className="new_err_msg">
									    <i className="las la-info-circle"/>{errors?.['card_cvv']}
									  </label> : ''
	            }
	            <div className="fitem half-fitem">
	              <div className="fitem half-fitem">
	                <label htmlFor="expiration-month">Expiration Month</label>
	                <input
	                  id="expiration-month"
	                  name="expiration-month"
	                  type="text"
	                  maxLength={2}
	                  placeholder="MM"
	                  inputMode="numeric"
	                  className="form--control twhite"
	                  onPaste={(event) => {
	                    if (event.clipboardData.getData('Text').match(/[^\d]/)) {
	                      event.preventDefault();
	                    }
	                  }}
	                  onKeyPress={(e) => {
	                    const pattern = /[0-9]/;
	                    const inputChar = String.fromCharCode(e.charCode);
	                    if (!pattern.test(inputChar)
	                    ) {
	                      // invalid character, prevent input
	                      e.preventDefault();
	                    }
	                  }}
	                  onChange={(e) => { this.setState({ card_expiry_month: e.target.value }) }}
	                />
	                {errors?.['card_expiry_month'] ? <label className="new_err_msg"><i className="las la-info-circle"/>{errors?.['card_expiry_month']}</label> : ''}
	              </div>
	              <div className="fitem half-fitem">
	                <label>Expiration Year</label>
	                <input
	                  type="text"
	                  maxLength={4} 
	                  placeholder="YYYY"
	                  inputMode="numeric"
	                  className="form--control twhite"
	                  onPaste={(event) => {
	                    if (event.clipboardData.getData('Text').match(/[^\d]/)) {
	                      event.preventDefault();
	                    }
	                  }}
	                  onKeyPress={(e) => {
	                    const pattern = /[0-9]/;
	                    const inputChar = String.fromCharCode(e.charCode);
	                    if (!pattern.test(inputChar)
	                    ) {
	                      // invalid character, prevent input
	                      e.preventDefault();
	                    }
	                  }}
	                  onChange={(e) => { this.setState({ card_expiry_year: e.target.value }) }} 
	                />
	                {errors?.['card_expiry_year'] ? <label className="new_err_msg"><i className="las la-info-circle"/>{errors?.['card_expiry_year']}</label> : ''}
	              </div>
	            </div>
	          </React.Fragment>
	      }
	      <div className="fitem">
	        <label>Received By</label>
	        <Select
	          showSearch
	          defaultValue=""
	          className="swhite"
	          filterOption={false}
	          value={payment_log.received_by_uuid}
	          onChange={(e) => { this.onReceiveChange(e) }}
	          onSearch={(e) => this.onSearchReceivedBy(e)}
	          onBlur={() => this.onSearchReceivedBy()}
	        >
	          <Option value={payment_log?.received_by_uuid}>
	            {payment_log?.received_by}
	          </Option>
	          {/* {map(staffList?.results, (item) => {
						return (
							<Option key={item.uuid}>{item.first_name} {item.last_name}</Option>
						)
						})} */}
	        </Select>
	        {errors['payment_log.received_by_uuid'] ? <label className="new_err_msg"><i className="las la-info-circle"></i>{errors['payment_log.received_by_uuid']}</label> : ''}
	      </div>
	    </div>
	  	</div>
	}

	renderPayment = () => {
	  const {log_type} = this.state;

	  return <div>
	    <div className="fitem">
	      <div className="fitem-check">
	        <input
	          id="check"
	          name="check"
	          type="radio"
	          className="fitem-ck-input"
	          checked={log_type === 'check'}
	          onChange={(e) => { this.onLogTypeChange(e) }}
	        />
	        <label htmlFor="check" className="fitem-ck-txt">Check Payment</label>
	      </div>
	    </div>
	    <div className="fitem">
	      <div className="fitem-check">
	        <input
	          id="card"
	          name="card"
	          type="radio"
	          className="fitem-ck-input"
	          checked={log_type === 'card'}
	          onChange={(e) => { this.onLogTypeChange(e) }}
	        />
	        <label htmlFor="card" className="fitem-ck-txt">Card Payment</label>
	      </div>
	    </div>
		
	    { 
	      log_type === 'check' ?
	        this.renderCheckPayment() : null
	    }
	    { 
	      log_type === 'card' ?
	        this.renderCardPayment() : null
	    }
	  	</div>
	}

	renderPrices = () => {
	  const {calculated_price} = this.state;

	  return <React.Fragment>
	    <div className="fitem">
	      <label className="read-only-input" htmlFor="original-price">Original Price Per Service</label>
	      <input
	        type="text"
	        readOnly={true}
	        disabled={true}
	        id="original-price"
	        name="original-price"
	        className="read-only-input disable"
	        value={`$${formatToCurrency(calculated_price?.original_price)}`}
	      >
	      </input>
	    </div>
	    <div className="fitem">
	      <label htmlFor="original-price" className="read-only-input">Discounted Price Per Service</label>
	      <input
	        type="text"
	        readOnly={true}
	        disabled={true}
	        id="original-price"
	        name="original-price"
	        className="read-only-input disable"
	        value={`$${formatToCurrency(calculated_price?.discounted_per_service)}`}
	      >
	      </input>
	    </div>
	    <div className="fitem">
	      <label htmlFor="original-price" className="read-only-input">Total Pre-pay Amount</label>
	      <input
	        type="text"
	        readOnly={true}
	        disabled={true}
	        id="original-price"
	        name="original-price"
	        className="read-only-input disable"
	        value={`$${formatToCurrency(calculated_price?.total_prepay)}`}
	      >
	      </input>
	    </div>
	    <div className="fitem">
	      <label htmlFor="original-price" className="read-only-input">Taxes (If applicable)</label>
	      <input
	        type="text"
	        readOnly={true}
	        disabled={true}
	        id="original-price"
	        name="original-price"
	        className="read-only-input disable"
	        value={`$${formatToCurrency(calculated_price?.taxes)}`}
	      >
	      </input>
	    </div>
	    <div className="fitem">
	      <label htmlFor="original-price" className="read-only-input">Pre-pay Amount Due</label>
	      <input
	        type="text"
	        readOnly={true}
	        disabled={true}
	        id="original-price"
	        name="original-price"
	        className="read-only-input disable"
	        value={`$${formatToCurrency(calculated_price?.prepay_amount)}`}
	      >
	      </input>
	    </div>
	  </React.Fragment>
	}


	renderForm = () => {
	  const {
	    selected_service_order,
	    selected_discount,
	    calculated_price,
	    selected_months,
	    issued_by_user,
	    service_orders,
	    payment_log,
	    staff_list,
	    discounts,
	    months,
	    errors
	  } = this.state;

	  return <div className={'form-group'}>
	    <div className="fitem">
	      <label>Service Order</label>
	      <Select
	        showSearch
	        className=""
	        filterOption={false}
	        value={selected_service_order}
	        onChange={(e) => { this.onServiceOrderChange(e) }}
	      >
	        {
						service_orders?.map((item) => {
						  return (
						    <Option key={item?.uuid} value={item?.uuid}>{item?.service_order_number}</Option>
						  );
						})
	        }
	      </Select>
	      {errors?.['selected_service_order'] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.['selected_service_order']}</label> : ''}
	    </div>
	    <div style={{display: "flex", alignItems: "center", justifyContent: "space-between"}}>
	      <div className="fitem">
	        <label>Months<sup>*</sup></label>
	        <Select
	          showSearch
	          filterOption={false}
	          value={selected_months}
	          onChange={(e) => { this.onMonthsChange(e) }}
	        >
	          {
							months?.map((item) => {
							  return (
							    <Option key={item} value={item}>{item}</Option>
							  );
							})
	          }
	        </Select>
	        {errors?.['selected_months.uuid'] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.['selected_months.uuid']}</label> : ''}
	      </div>
	      <div className="fitem">
	        <label>Discount (%)<sup>*</sup></label>
	        <Select
	          showSearch
	          filterOption={false}
	          value={selected_discount}
	          onChange={(e) => { this.onDiscountChange(e) }}
	        >
	          {
				discounts?.map((item) => {
				  return (
				    <Option key={item} value={item}>{item}</Option>
				  );
				})
	          }
	        </Select>
	        {errors?.['selected_discount'] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.['selected_discount']}</label> : ''}
	      </div>
	    </div>

	    { this.state.show_prices && selected_service_order !== '' ? this.renderPrices() : null }

	    {
	      Object.entries(calculated_price).length > 0 && selected_service_order !== ''? 
	        <React.Fragment>
	          <h5>Payment Method</h5>
	          { this.renderPayment() }
	        </React.Fragment> : null
	    }

	    <div className="fitem" style={{marginTop: "10px"}}>
	      <label>Issue By<sup>*</sup></label>
	      <Select
	        showSearch
	        defaultValue=""
	        className=""
	        filterOption={false}
	        value={payment_log.received_by_uuid}
	        onChange={(e) => { this.onReceiveChange(e) }}
	        onSearch={(e) => this.onSearchReceivedBy(e)}
	        onBlur={() => this.onSearchReceivedBy()}
	      >
	        <Option value={payment_log?.received_by_uuid}>{payment_log?.received_by}</Option>
	        {
						staff_list?.results?.map((item) => {
						  return (
						    <Option key={item.uuid} value={item.uuid}>{item.first_name} {item.last_name}</Option>
						  )
						})
	        }
	      </Select>
	    </div>
	  </div>
	}

	render() {
	  const { visible } = this.props;
	  const {
	    loader,
	    errors,
	    log_type,
	    show_prices,
	    payment_log,
	    calculated_price,
	    confirmation_modal_visible,
	  } = this.state;

	  let have_amount; 
		
	  if(log_type === 'check' && (payment_log.amount_received === '' || 
			parseFloat(payment_log.amount_received).toFixed(2) !== parseFloat(calculated_price.prepay_amount).toFixed(2)))
	  {
	    have_amount = false;
	  }
	  else if (log_type === 'cc' && parseInt(calculated_price?.prepay_amount) === 0)
	  {
	    have_amount = false;
	  }
	  else if (log_type !== '')
	  {
	    have_amount = true;
	  }

	  const disable_creation = (!show_prices && !have_amount) || log_type === '';
	
	  return (
		  <Drawer
	      placement={'right'}
	      closable={false}
	      visible={visible}
	      key={'right'}
	      width={'400'}
	      className="drawer-wrapper"
	      onClose={() => this.props.closeDrawer(false)}
		  >
	      <div className="rdrawer">
	        <div className="card-row">
	          <div className="card-full">
	            {loader && <Loader/>}
	            <h4>Create Pre-Pay</h4>
	            {this.renderForm()}
	          </div>

	          <div className="footer" style={{ 'width': '400px' }}>
	            <button
	              className="btn btn-brand btn-bdr"
	              onClick={() => {this.setState({ confirmation_modal_visible: true})}}
	            >Cancel</button>
	            <button
	              onClick={() => {this.validatePrepay()}}
	              disabled={disable_creation}
	              className={`btn btn-warning ${disable_creation ? 'disbale_btn' : ''}`}
	            >Create Pre-Pay</button>
	          </div>
			  	</div>
	      </div>
	      <Modal
	        visible={confirmation_modal_visible}
	        okText={"Yes"}
	        cancelText={"Cancel"}
	        className="delete_user_modal"
	        width={400}
	        onOk={() => { 
	          this.setState({ confirmation_modal_visible: false});
	          this.props.closeDrawer(false);
	        }}
	        onCancel={() => { this.setState({ confirmation_modal_visible: false})}}
	      >
	        <div>
	          <h3>Cancel Pre-pay</h3>
	          <p>Are you sure that you want to cancel the creation of this Pre-pay?</p>
	        </div>
	      </Modal>
		  </Drawer>
	  );
	}
}

export default PrePayment;